import $ from 'jquery';

function AccordionWrap(element) {
  this.element = element;
  this.$element = $(element);
  this.init();
  this.ready();
}

AccordionWrap.prototype = {
  init() {
    const classes = (this.getClasses()) ? this.getClasses() : '';
    const status = (this.getStatus()) ? ` style="display: ${this.getStatus()}"` : '';
    this.$element
      .next('.accordion-content')
      .addBack()
      .wrapAll(`<div class="accordion-item ${classes}"${status}></div>`);
  },
  getClasses() {
    let $classes = null;
    if (this.$element.hasClass('under-tab')) {
      $classes = 'under-tab';
      let elemClasses = this.$element.attr('class');
      elemClasses = elemClasses.split(' ');

      for (let i = 0; i < elemClasses.length; i += 1) {
        const val = elemClasses[i];
        if (val.substring(0, 10) === 'under-tab-') {
          $classes += ` ${val}`;
        }
      }
    }

    return $classes;
  },
  getStatus() {
    let $status;
    if (this.$element.hasClass('under-tab')) {
      $status = (this.$element.is('.under-tab-0')) ? 'block' : 'none';
    }

    return $status;
  },
  ready() {
    setTimeout(() => {
      this.$element.addClass('ready');
    }, 200);
  },
};

export default AccordionWrap;
